import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class KijijiCPC extends Component {
  render() {
    return (
      <EntityList apiRoute='api/kijijicpc' title='Coûts par clic Kijiji' editTitle='Coûut par clic Kijiji' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Valeur', Column: 'Value'},
        {Description: 'Défaut', Column: 'Default'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default KijijiCPC;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/kijijiCPC.js
 **/